<hr>
<div *ngIf="!loading.subscription" class="company-dids-page">
  <div class="company-dids-page__container">
    <div ngbDropdown class="vox-dropdown dropdown">
      <button class="vox-btn btn btn-outline-secondary vox-text-field" ngbDropdownToggle>
        <span>
          <i [ngClass]="TAB_ICONS[currentTab]"></i>
          {{('company.dids.nav-tabs.' + currentTab + '.label') | translate }}
        </span>
      </button>
      <div ngbDropdownMenu class="dropdown-menu">
        <button class="dropdown-item" ngbDropdownItem (click)="switchTab('dids-list')">
          <i class="icon-small-telephone"></i>
          <span translate>company.dids.nav-tabs.dids-list.label</span>
        </button>
        <button class="dropdown-item" ngbDropdownItem (click)="switchTab('verification-data')">
          <i class="icon-small-template"></i>
          <span translate>company.dids.nav-tabs.verification-data.label</span>
        </button>
      </div>
    </div>
    <ul ngbNav #nav="ngbNav" [activeId]="currentTab" class="nav-pills" orientation="vertical">
      <li ngbNavItem="dids-list">
        <a ngbNavLink>
          <i class="icon-small-telephone"></i>
          <span translate>company.dids.nav-tabs.dids-list.label</span>
        </a>
        <ng-template ngbNavContent>
          <div class="dids-list">
            <div class="dids-list__title">
              <div class="dids-list__title-container">
                <h3 class="vox-heading-3" translate>company.dids.dids-list.title</h3>
              </div>
              <div class="dids-list__buttons">
                <button class="vox-btn vox-btn-secondary" (click)="openCreateDidOrderPopup()"
                  [disabled]="subscription?.status === SUBSCRIPTION_STATUS.IN_TRIAL"
                  translate>company.dids.dids-list.buttons.create-did
                  <i [ngbTooltip]="'company.dids.dids-list.buttons.create-did-tooltip'| translate"
                    *ngIf="subscription?.status === SUBSCRIPTION_STATUS.IN_TRIAL" class="icon-small-info"></i>
                </button>
                <button class="vox-btn vox-btn-secondary" (click)="openAddPortDidPopup()"
                  translate>company.dids.dids-list.buttons.add-existing-did
                </button>
                <button class="vox-btn vox-btn-secondary" (click)="openAddTestingDidPopup()"
                  translate>company.dids.dids-list.buttons.add-testing-did
                </button>
                <button class="vox-btn vox-btn-secondary" [ladda]="isAddingTemporaryDid" (click)="onAddTemporaryDid()"
                  >{{'company.dids.dids-list.buttons.add-temporary-did' | translate }}
                </button>
              </div>
            </div>
            <gdp-company-dids-filters (onFilter)="onFilter($event)"
              [lockedFilters]="[{name: 'company_id', value: company.companyId}]">
            </gdp-company-dids-filters>
            <gdp-dids-table [dids]="dids" [company]="company"
              [planAddonHandling]="currentPlan.meta_data.shop.phone_number.addon_management"
              [loading]="loading.dids || loading.info"
              (onReplaceWithExistingDid)="onReplaceWithExistingDid($event)"
              (onReplaceWithNewDid)="onReplaceWithNewDid($event)"
              (onFetchDidsChanges)="onFetchDidsChanges()"
              (onUpdateDidProvider)="onUpdateDidProvider($event)"
            ></gdp-dids-table>
            <gdp-table-pagination (onSelectPageSize)="selectPageSize($event)"
              (onChangeCurrentPage)="changeCurrentPage($event)" [totalPages]="pagination.totalPages"
              [pagination]="pagination" [selectedPageSize]="pageSize"></gdp-table-pagination>
          </div>
        </ng-template>
      </li>
      <li ngbNavItem="verification-data">
        <a ngbNavLink>
          <i class="icon-small-template"></i>
          <span translate>company.dids.nav-tabs.verification-data.label</span>
        </a>
        <ng-template ngbNavContent>
          <div class="verification-data">
            <div class="verification-data__title">
              <div class="verification-data__buttons">
                <button class="d-none vox-btn vox-btn-secondary" (click)="openCreateVerificationDataPopup()"
                  translate>company.dids.verification-data.buttons.create
                </button>
              </div>
            </div>
            <gdp-verification-data-table [verificationDataList]="verificationDataList"
              [loading]="loading.verificationData" [company]="company"></gdp-verification-data-table>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="company-dids-page__tab-container"></div>
  </div>
</div>

<div *ngIf="loading.verificationData || loading.subscription" class="company-dids-page__container">
  <ul class="nav-pills" style="max-width: 130px; margin-left: 20px; padding-left: 0px;">
    <ngx-skeleton-loader class="nav-item" count="2"
      [theme]="{'height': '80px', 'width': '100px', 'margin-left': '3px'}"></ngx-skeleton-loader>
  </ul>
  <div class="company-dids-page__tab-container">
    <div class="dids-list__title" style="display: flex; margin-bottom: 30px;">
      <ngx-skeleton-loader class="nav-item" count="2"
        [theme]="{'height': '50px', 'width': '180px', 'margin-right': '10px'}"></ngx-skeleton-loader>
    </div>
    <ngx-skeleton-loader class="nav-item" count="2" [theme]="{'height': '250px'}"></ngx-skeleton-loader>
  </div>
</div>
